/**
 * What a caller does when they produce a plan.
 *
 * Approving is the clinical act the surgeon carries liability for; proposing is the delegable
 * half, preparing a plan for a surgeon to accept. Nobody chooses between them - the act follows
 * from what the caller may do, and the API decides again on the request.
 */
export type PlanAct = 'approve' | 'propose' | 'none';

/** Approving wins where both are held: proposing is a fallback, not a choice. */
export function planAct(canApprove: boolean, canPropose: boolean): PlanAct {
    if (canApprove) {
        return 'approve';
    }

    if (canPropose) {
        return 'propose';
    }

    return 'none';
}
